/**
 * The country's timezone in the times dialog: the timezone picker (every
 * IANA zone, a suggestion for known countries, the local time now) and one
 * line on what it governs.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import { TimezoneSelectField } from '@/features/drop-generator/components/board-header/times/TimezoneSelectField';
import { countryKeyToIso2 } from '@/utils/country-flag-emoji';

interface Props {
  countryKey: string;
  value: string | null;
  onChange: (tz: string) => void;
}

export const TimezoneField: FC<Props> = ({ countryKey, value, onChange }) => (
  <div className="flex flex-col gap-1.5">
    <TimezoneSelectField value={value} countryKey={countryKeyToIso2(countryKey)} onChange={onChange} />
    <p className="text-xs text-muted-foreground">
      The recipients&apos; clock. You type every time in Danish time; the window and the layout time are saved on this clock, and the hour chart runs on it. Container schedules stay fixed on the Danish clock and are translated to it, day by day.
    </p>
  </div>
);
